import React from 'react';
import { Form, Input, Button } from 'antd';
const FormItem = Form.Item;
import Editor from 'react-umeditor';
import { bindValue, bindEvent, setFormCtlLayout, AddFormCtlCommonAttribute } from './sgiFormCtlComm'
import { sgiFormCtlBaseFun } from "./sgiFormCtlBaseFun"
import { getConstByKey } from './sgiBaseComp/SgiCommon';
require('./sgiEditor.less');

class SgiEditor extends React.Component {

    static defaultProps = {
    };  // 注意这里有分号
    static propTypes = {
    };  // 注意这里有分号



    constructor(props) {
        super(props);
        //初始化state属性
        this.initState();
    }

    /**
    * 根据描述创建文本框
    * @param {父组件} parentModule 
    * @param {组件描述} moduleDesc 
    * @param {绑定实例ID} bdInst 
    * @param {对象工厂} objFct 
    * @param {make类型} type 
    */
    fieldCtl_mk(parentModule, moduleDesc, bdInst, objFct, type) {

        //获取需要展示的数据信息       
        if (!moduleDesc) {
            return;
        }
        //转换基础属性
        this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
        //转换form公共属性
        AddFormCtlCommonAttribute(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
        //设置布局
        setFormCtlLayout(moduleDesc, this.state.formItemProps, this.state.inputprops);
        //绑定值
        bindValue(this, moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
        //绑定事件
        bindEvent(this, moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.functions, type);
        //添加拖拽布局信息 根据type类型
        // addFormCtlDndInfo(this, this.state.formItemProps, this.state.inputprops, type);
    }

    AddInputAttribute(moduleDesc, formItemProps, inputprops) {
        // // 组件宽度
        // var width = moduleDesc.ctlW;
        // if (width) {
        //     this.state.wrapperStyle = { ...this.state.wrapperStyle, width: (width * 100 / 24 + '%') };
        // } else if (width == "") {
        //     this.state.wrapperStyle = { ...this.state.wrapperStyle, width: '100%' };
        // }

        // // 组件高度
        // var height = moduleDesc.ctlH;
        // if (height) {
        //     this.state.wrapperStyle = { ...this.state.wrapperStyle, height: height + 'px' };
        // } else if (height == "") {
        //     this.state.wrapperStyle = { ...this.state.wrapperStyle, height: '100%' };
        // }

        // id
        var wrapperId = getConstByKey(this, moduleDesc.cId);
        if (wrapperId) this.state.wrapperId = wrapperId;

        // // 修改事件
        // var onContentStateChange = moduleDesc.chgLsn;
        // if (onContentStateChange) {
        //     var $chg = new Function("module", "objFct", "record", "index", onContentStateChange);
        //     this.state.onContentStateChange = $chg;
        // }

        // // 进入事件
        // var onFocus = moduleDesc.inLsn;
        // if (onFocus) {
        //     var $in = new Function("module", "objFct", "record", "index", onFocus);
        //     this.state.onFocus = $in;
        // }

        // // 离开事件
        // var onBlur = moduleDesc.lveLsn;
        // if (onBlur) {
        //     var $lve = new Function("module", "objFct", "record", "index", onBlur);
        //     this.state.onBlur = $lve;
        // }

        // 文件上传地址
        var fileUploadUrl = moduleDesc.fileUploadUrl;
        if (fileUploadUrl) this.state.fileUploadUrl = fileUploadUrl;

        // 隐藏工具栏
        var toolbarHidden = moduleDesc.toolbarHidden;
        if (toolbarHidden) this.state.toolbarHidden = toolbarHidden;
    }

    getIcons() {
        if (this.state.toolbarHidden) {
            return [];
        }
        return [
            "source | undo redo | bold italic underline strikethrough fontborder | ",
            "paragraph fontfamily fontsize | superscript subscript | ",
            "forecolor backcolor | removeformat | insertorderedlist insertunorderedlist | selectall | ",
            "cleardoc  | indent outdent | justifyleft justifycenter justifyright | touppercase tolowercase | ",
            "horizontal date time  | image formula spechars | inserttable"
        ]
    }

    getPlugins() {
        var plugins = {
            image: {
                uploader: {
                    url:this.state.fileUploadUrl || sgiConfig.fileAction,
                    // url: "https://www.egssoft.com.cn:8895/fileserver/uploadFile",
                    name: "file",
                    filter: (res) => res.fileDownloadUri
                }
            }
        }
        return plugins
    }

    render() {

        if (!this.loaded) {
            var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
            //组装属性 初始化属性到this.state
            this.fieldCtl_mk(parentModule, moduleDesc, bdInst, objFct, type);
            this.loaded = true;
        }

        let icons = this.getIcons();
        let plugins = this.getPlugins();

        //formitem会变editor的样式，导致显示错乱，特修改会原属性
        this.state.inputprops.style["line-height"] = "22px";

        return (
            <FormItem {...this.state.formItemProps} >
                <Editor icons={icons} plugins={plugins} {...this.state.inputprops} readOnly/>
            </FormItem >
        )
    }
}


//给类添加公共方法
Object.assign(SgiEditor.prototype, sgiFormCtlBaseFun);

export { SgiEditor };
export default SgiEditor;


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiEditor.js